import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=b99f76e4&scoped=true"
import script from "./UsersManagement.vue?vue&type=script&lang=js"
export * from "./UsersManagement.vue?vue&type=script&lang=js"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=b99f76e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99f76e4",
  null
  
)

export default component.exports